import React, { useEffect, useState } from 'react';
import SideBar from './SideBar';
import TopNav from './TopNav';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

const InventoryMovementReports = () => {
    const [inventoryData, setInventoryData] = useState([]);

    useEffect(() => {
        // Simulate fetching data (replace with your data fetching logic)
        const fetchData = async () => {
            const data = [
                { id: 1, product: "Product A", movement: "Added", quantity: 100 },
                { id: 2, product: "Product B", movement: "Removed", quantity: 30 },
                { id: 3, product: "Product C", movement: "Added", quantity: 50 },
            ];
            setInventoryData(data);
        };

        fetchData();
    }, []);

    return (
        <div className="d-flex">
            <SideBar />
            <div className="flex-grow-1 d-flex justify-content-end p-3" style={{ maxWidth: '80%', marginLeft: 'auto' }}>
                <div style={{ width: '100%', textAlign: 'right' }}>
                    <TopNav />
                    <h4 className="mb-4 text-center" style={{marginTop: 65}}>Inventory Movement Report</h4>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Product</th>
                                    <th scope="col">Movement Type</th>
                                    <th scope="col">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inventoryData.map((item) => (
                                    <tr key={item.id}>
                                        <th scope="row">{item.id}</th>
                                        <td>{item.product}</td>
                                        <td>{item.movement}</td>
                                        <td>{item.quantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryMovementReports;